var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"telegram-id","title":"Link your Telegram id to 3proj","hide-footer":true,"no-close-on-backdrop":""}},[_c('TelegramID',{on:{"close":function($event){return _vm.$bvModal.hide('telegram-id')}}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }